<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="ded _idGenParaOverride-1">To my husband, Michael, who in a less fuel-injected, power-windowed, air-bagged era was the undisputed king of the car yard.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// GiveTheDevilHisDue-5.vue?35cc470a